<template>
    <div>
        <v-divider class="grey darken-4" style="border-width: 2px 0 0;" />
        <slot />
    </div>
</template>

<script>
export default {
    props: {
    },
    components: {
    },
    data: () => {
        return {
        }
    },
    mounted() {
    },
    methods: {
    },
}
</script>

<style lang='scss' scoped>
</style>